import React from 'react';
import ContentLoader from 'react-content-loader';
import CustomTable from '../CustomTable/CustomTable';

const OfferListLoaderItem = () => {
  return (
    <CustomTable.Row className="offers-list-item">
      <CustomTable.Cell>
        <div className="offer-pic">
          <ContentLoader
            height={64}
            width={64}
            speed={2}
            primaryColor="#f5f5fa"
            secondaryColor="#f8f8f9"
            preserveAspectRatio="xMaxYMax"
            className="offers-list-loader"
            style={{
              width: '64px',
            }}
          >
            <circle cx="32" cy="32" r="32" />
          </ContentLoader>
        </div>
      </CustomTable.Cell>

      <CustomTable.Cell>
        <ContentLoader
          height={24}
          width={400}
          speed={2}
          primaryColor="#f5f5fa"
          secondaryColor="#f8f8f9"
          preserveAspectRatio="xMaxYMax"
          className="offers-list-loader"
          style={{
            width: '400px',
          }}
        />
      </CustomTable.Cell>

      <CustomTable.Cell>
        <ContentLoader
          height={24}
          width={250}
          speed={2}
          primaryColor="#f5f5fa"
          secondaryColor="#f8f8f9"
          preserveAspectRatio="xMaxYMax"
          className="offers-list-loader"
          style={{
            width: '250px',
          }}
        />
      </CustomTable.Cell>

      <CustomTable.Cell className="text-right">
        <ContentLoader
          height={24}
          width={80}
          speed={2}
          primaryColor="#f5f5fa"
          secondaryColor="#f8f8f9"
          preserveAspectRatio="xMaxYMax"
          className="offers-list-loader"
          style={{
            width: '80px',
          }}
        />
      </CustomTable.Cell>

      <CustomTable.Cell className="text-right">
        <ContentLoader
          height={24}
          width={80}
          speed={2}
          primaryColor="#f5f5fa"
          secondaryColor="#f8f8f9"
          preserveAspectRatio="xMaxYMax"
          className="offers-list-loader"
          style={{
            width: '80px',
          }}
        />
      </CustomTable.Cell>

      <CustomTable.Cell>
        {' '}
        <ContentLoader
          height={24}
          width={120}
          speed={2}
          primaryColor="#f5f5fa"
          secondaryColor="#f8f8f9"
          preserveAspectRatio="xMaxYMax"
          className="offers-list-loader"
          style={{
            width: '120px',
          }}
        />
      </CustomTable.Cell>

      <CustomTable.Cell className="text-right">
        <ContentLoader
          height={24}
          width={80}
          speed={2}
          primaryColor="#f5f5fa"
          secondaryColor="#f8f8f9"
          preserveAspectRatio="xMaxYMax"
          className="offers-list-loader"
          style={{
            width: '80px',
          }}
        />
      </CustomTable.Cell>
    </CustomTable.Row>
  );
};

export default OfferListLoaderItem;
